export default __webpack_public_path__ + "static/media/transporte-colectivo1.e2922c18.jpg";